export enum MessagesType {
  Default = 'Default',
  Municipality = 'Municipality',
  Reopened = 'Reopened',
  Feedback = 'Feedback',
  Automatic = 'Automatic',
}
